import { render } from "./system-stats.vue?vue&type=template&id=2b8dbb3d&scoped=true"
import script from "./system-stats.vue?vue&type=script&lang=js"
export * from "./system-stats.vue?vue&type=script&lang=js"

import "./system-stats.vue?vue&type=style&index=0&id=2b8dbb3d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8dbb3d"]])

export default __exports__